import React from 'react';
import {GeneralAssistantComponent} from './generalAssistantComponent';
import {DefaultRootState, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

export const GeneralAssistant = React.memo(() => {
    const assistantConfig = useSelector((state: DefaultRootState) => state.config.uiConfig.aiAssistant.globalAssistant);
    const navigate = useNavigate();
    if (!assistantConfig.enabled) {
        navigate('/');
    }

    return <GeneralAssistantComponent />;
});
